/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2026
///                                    RXO Inc.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of RXO Inc. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { format } from "date-fns";

import { dateFormat, division as userDivision } from "../../../helpers/types";
import {
  fetchBidSummary,
  fetchBidMessages
} from "../../../slices/bidSummarySlice";
import { fetchBidDetails } from "../../../slices/bidDetailsSlice";
import SubmitPricingModal from "../pricing/SubmitPricingModal";
import { FormattedMessage } from "react-intl";
import messages from "../../../helpers/messages";
import SelfPricedEarlyCloseBidActions from "./SelfPricedEarlyCloseBidActions";

function SubmitPricingState({
  summary,
  division,
  role,
  user,
  showSelfPricedEarlyCloseBid = false
}) {
  const dispatch = useDispatch();
  const route = useLocation().pathname.split("/")[3] || "";
  const [openModal, setOpenModal] = useState(false);

  const { closeDateUTC, bidId } = summary;
  const date = format(
    new Date(closeDateUTC),
    division === userDivision.coy ? dateFormat.MMddyy : dateFormat.ddMMyy
  );

  const handleClose = submitted => {
    if (submitted) {
      dispatch(fetchBidSummary({ bidId, role }));
      route === "summary" && dispatch(fetchBidMessages(bidId));
      route === "details" && dispatch(fetchBidDetails(bidId));
    } else {
      setOpenModal(false);
    }
  };

  return (
    <>
      <p className="inline-block font-size-14 pt-16 mb-0">
        <FormattedMessage
          {...messages.lanesHaveBeenImportedMessage}
          values={{ date: date }}
        />
      </p>
      <div className="fr py-8 my-2">
        <button
          className="text-button univers-67-bold-cond font-size-14 uppercase mx-8 h-32 px-16"
          data-testid="submit-pricing"
          onClick={() => setOpenModal(true)}
        >
          {messages.submitPricing.defaultMessage}
        </button>
        {showSelfPricedEarlyCloseBid && user ? (
          <SelfPricedEarlyCloseBidActions summary={summary} user={user} />
        ) : null}
      </div>
      {openModal && (
        <SubmitPricingModal bidId={bidId} handleClose={handleClose} />
      )}
    </>
  );
}

export default SubmitPricingState;
